// extracted by mini-css-extract-plugin
export default {"active":"styles_active__YfgiC","disabled":"styles_disabled__FQZr7"};